import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Materials from './pages/Materials';
import MaterialExtras from './pages/MaterialExtras';
import Filaments from './pages/Filaments';
import Brands from './pages/Brands';
import Quotes from './pages/Quotes';
import QuoteDetail from './pages/QuoteDetail';
import Contacts from './pages/Contacts';
import Users from './pages/Users';
import FarmSettings from './pages/FarmSettings';
import SystemSettings from './pages/SystemSettings';
import SlicerSettings from './pages/SlicerSettings';
import SlicerQuotes from './pages/SlicerQuotes';
import SlicerQuoteDetail from './pages/SlicerQuoteDetail';
import SlicerJobs from './pages/SlicerJobs';
import SlicerJobDetail from './pages/SlicerJobDetail';
import Boxes from './pages/Boxes';
import ShippingMethods from './pages/ShippingMethods';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import PrintQueue from './pages/PrintQueue';
import FleetMachines from './pages/FleetMachines';
import FleetMachineModels from './pages/FleetMachineModels';
import SlicerPresets from './pages/SlicerPresets';
import SlicerFilamentSettings from './pages/SlicerFilamentSettings';
import SlicerQualitySettings from './pages/SlicerQualitySettings';
import AdminMachineModels from './pages/AdminMachineModels';
import AdminSlicerPresets from './pages/AdminSlicerPresets';
import AdminFilaments from './pages/AdminFilaments';
import AdminMaterials from './pages/AdminMaterials';
import AdminMaterialExtras from './pages/AdminMaterialExtras';
import AdminVATSettings from './pages/AdminVATSettings';
import KillSwitch from './pages/KillSwitch';
import AdminKillSwitch from './pages/AdminKillSwitch';
import AdminBrands from './pages/AdminBrands';

function ProtectedPage({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function AdminPage({ children }) {
  return (
    <ProtectedRoute requireAdmin>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Dashboard */}
            <Route path="/" element={<ProtectedPage><Dashboard /></ProtectedPage>} />

            {/* Print Queue */}
            <Route path="/print-queue" element={<ProtectedPage><PrintQueue /></ProtectedPage>} />
            <Route path="/slicer-jobs" element={<ProtectedPage><SlicerJobs /></ProtectedPage>} />
            <Route path="/slicer-jobs/:id" element={<ProtectedPage><SlicerJobDetail /></ProtectedPage>} />

            {/* Quotes */}
            <Route path="/slicer-quotes" element={<ProtectedPage><SlicerQuotes /></ProtectedPage>} />
            <Route path="/slicer-quotes/:id" element={<ProtectedPage><SlicerQuoteDetail /></ProtectedPage>} />
            <Route path="/quotes" element={<ProtectedPage><Quotes /></ProtectedPage>} />
            <Route path="/quotes/:id" element={<ProtectedPage><QuoteDetail /></ProtectedPage>} />
            <Route path="/contacts" element={<ProtectedPage><Contacts /></ProtectedPage>} />

            {/* Orders */}
            <Route path="/orders" element={<ProtectedPage><Orders /></ProtectedPage>} />
            <Route path="/orders/:id" element={<ProtectedPage><OrderDetail /></ProtectedPage>} />

            {/* Fleet */}
            <Route path="/fleet/machines" element={<ProtectedPage><FleetMachines /></ProtectedPage>} />
            <Route path="/fleet/machine-models" element={<ProtectedPage><FleetMachineModels /></ProtectedPage>} />

            {/* Stock */}
            <Route path="/filaments" element={<ProtectedPage><Filaments /></ProtectedPage>} />
            <Route path="/brands" element={<ProtectedPage><Brands /></ProtectedPage>} />
            <Route path="/materials" element={<ProtectedPage><Materials /></ProtectedPage>} />
            <Route path="/material-extras" element={<ProtectedPage><MaterialExtras /></ProtectedPage>} />

            {/* Settings */}
            <Route path="/farm-settings" element={<ProtectedPage><FarmSettings /></ProtectedPage>} />
            <Route path="/user-settings" element={<Navigate to="/farm-settings" replace />} />

            {/* Slicer Settings */}
            <Route path="/slicer-settings/presets" element={<ProtectedPage><SlicerPresets /></ProtectedPage>} />
            <Route path="/slicer-settings/filaments" element={<ProtectedPage><SlicerFilamentSettings /></ProtectedPage>} />
            <Route path="/slicer-settings/quality" element={<ProtectedPage><SlicerQualitySettings /></ProtectedPage>} />
            <Route path="/slicer-settings" element={<Navigate to="/slicer-settings/presets" replace />} />
            <Route path="/system-settings" element={<Navigate to="/slicer-settings/presets" replace />} />

            {/* Shipping */}
            <Route path="/shipping-methods" element={<ProtectedPage><ShippingMethods /></ProtectedPage>} />
            <Route path="/boxes" element={<ProtectedPage><Boxes /></ProtectedPage>} />

            {/* Users */}
            <Route path="/users" element={<ProtectedPage><Users /></ProtectedPage>} />

            {/* Kill Switch */}
            <Route path="/kill-switch" element={<ProtectedPage><KillSwitch /></ProtectedPage>} />

            {/* Admin */}
            <Route path="/admin/machine-models" element={<AdminPage><AdminMachineModels /></AdminPage>} />
            <Route path="/admin/slicer-presets" element={<AdminPage><AdminSlicerPresets /></AdminPage>} />
            <Route path="/admin/filaments" element={<AdminPage><AdminFilaments /></AdminPage>} />
            <Route path="/admin/materials" element={<AdminPage><AdminMaterials /></AdminPage>} />
            <Route path="/admin/material-extras" element={<AdminPage><AdminMaterialExtras /></AdminPage>} />
            <Route path="/admin/vat-settings" element={<AdminPage><AdminVATSettings /></AdminPage>} />
            <Route path="/admin/brands" element={<AdminPage><AdminBrands /></AdminPage>} />
            <Route path="/admin/kill-switch" element={<AdminPage><AdminKillSwitch /></AdminPage>} />

            {/* Catch-all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
